// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"2bb6225b","435":"b7ed2d0d","787":"8d0a538e","834":"88f07c0a"}[chunkId] + ".chunk.js";
};